import React, { useState } from "react";
import { Box, Radio, RadioGroup, FormControlLabel, Typography } from "@mui/material";
import ConfirmationModal from "../../../shared-components/confirmation-modal/ConfirmationModal";
import { useTranslation } from "react-i18next";
import { GATEWAY } from "../../../config/constant";
import warningCircle from "../../../assets/icons/warning-circle.svg"
import easeBuzzIcon from "../../../assets/icons/Easebuzz Logo Unit - White Text.svg"
import razorPayIcon from "../../../assets/icons/razorpay.svg"

const PaymentFailedModal = ({ open, onClose, onProceed }) => {
  const { t } = useTranslation();
  const [selectedGateway, setSelectedGateway] = useState(GATEWAY?.RAZORPAY);

  const handleChange = (event) => {
    setSelectedGateway(event.target.value);
  };

  const handleProceed = () => {
    if (onProceed) onProceed(selectedGateway);
    onClose?.();
  };

  return (
    <ConfirmationModal
      open={open}
      onClose={onClose}
      icon={warningCircle}
      title={t("paymentFailedModal.title")}
      confirmText={t("paymentFailedModal.button")}
      onConfirm={handleProceed}
      hideCloseIcon={false}
      disableBackdropClick={true}
      customClassName="noWidthLimit"
      confirmButtonProps={{
        sx: {
          height: "44px",
          borderRadius: "8px",
          textTransform: "none",
          background: "#1A407D",
          fontWeight: 600,
          "&:hover": { backgroundColor: "#092552" },
        },
      }}
    >
      <Box>
        <Typography sx={{ fontSize: '14px'}}>
          {t("paymentFailedModal.desc")}
        </Typography>
        <Typography sx={{ fontSize: '14px', mb: 2}}>
          {t("paymentFailedModal.desc2")}
        </Typography>
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 500,
            mb: 1,
          }}
        >
          {t("paymentFailedModal.select")}
        </Typography>

        <RadioGroup
          row
          value={selectedGateway}
          onChange={handleChange}
          sx={{ gap: 2 }}
        >
          <FormControlLabel
            value={GATEWAY?.EASEBUZZ}
            control={<Radio sx={{ color: "#1A407D", "&.Mui-checked": { color: "#1A407D" } }} />}
            label={
              <img src={easeBuzzIcon} alt="easeBuzz" />
            }
          />
          <FormControlLabel
            value={GATEWAY?.RAZORPAY}
            control={<Radio sx={{ color: "#1A407D", "&.Mui-checked": { color: "#1A407D" } }} />}
            label={
              <img src={razorPayIcon} alt="razorPay" />
            }
          />
        </RadioGroup>
      </Box>
    </ConfirmationModal>
  );
};

export default PaymentFailedModal;